'use client'

import React, { useState, useEffect } from 'react'
import { Select } from 'antd'
import { useRouter } from 'next/navigation'
import { buildSearchParamsToRoutePath } from '@/utils/index'
import { useTranslation } from '@/i18n/client'

interface DropdownProps {
  lng: string
  type?: string
  path: string
  page: number
  pageSize: number
  total: number
  activeKey: string
  currentParams?: Record<string, any> // 用于动态路由参数
  useStaticRouting?: boolean // 用于控制是否使用静态路由
}

export default function Dropdown({ lng, type = 'notFree', path, page, pageSize, total, activeKey, currentParams }: DropdownProps) {
  const { t } = useTranslation(lng)
  const router = useRouter()
  const [currentKey, setCurrentKey] = useState(activeKey)
  useEffect(() => {
    setCurrentKey(activeKey)
  }, [activeKey])

  const handleChange = async (value: string) => {
    // 使用动态路由和静态渲染
    const newParams = { ...currentParams, order: value, page: 1 }
    router.push(buildSearchParamsToRoutePath(lng, path, newParams))
  }

  const blogOptions = [
    {
      label: t('defaultOrderName'),
      value: '0'
    },
    {
      label: t('readingHeightToLowOrderName'),
      value: '2'
    },
    {
      label: t('newestBlogOrderName'),
      value: '1'
    }
  ]

  const freeOptions = [
    {
      label: t('defaultOrderName'),
      value: '0'
    },
    {
      label: t('newestOrderName'),
      value: '1'
    }
    // {
    //   label: t('hotOrderName'),
    //   value: '2'
    // },
  ]

  const notFreeOptions = [
    {
      label: t('defaultOrderName'),
      value: '0'
    },
    {
      label: t('newestOrderName'),
      value: '1'
    },
    {
      label: t('hotOrderName'),
      value: '2'
    },
    {
      label: t('priceHeightToLowOrderName'),
      value: '3'
    },
    {
      label: t('priceLowToHeightOrderName'),
      value: '4'
    }
  ]

  return (
    <div className="flex items-center pl-1.5 pr-1.5 sm:pr-0">
      <span className="hidden py-2 pr-1.25 text-[14px] sm:inline-block">{t('sortBy')}：</span>
      <div className={`w-full ${type === 'blog' ? 'sm:w-[214px]' : 'sm:w-[186px]'}`}>
        <Select style={{ width: '100%' }} value={currentKey} onChange={handleChange} options={type === 'blog' ? blogOptions : type === 'free' ? freeOptions : notFreeOptions} />
      </div>
      {total > 0 && (
        <span className="ml-2.5 hidden py-2 align-middle text-[14px] sm:inline-block">
          {t('show')}：<span>{`${(page - 1) * pageSize + 1} - ${Math.min(page * pageSize, total)}`}</span>
        </span>
      )}
    </div>
  )
}
